import { HubSpotForm } from '@/components/HubSpotForm/HubSpotForm'

import type * as React from 'react'
import type { HubspotForm } from '@/gen/sanity/schema'

export const SanityHubSpotForm: React.FC<{ sanityComponent: HubspotForm }> = ({ sanityComponent }) => {
  if (!sanityComponent.portalId || !sanityComponent.formId) {
    return null
  }

  return <HubSpotForm portalId={sanityComponent.portalId} formId={sanityComponent.formId} />
}
